import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from './pages/EditPage';
import {AuthorizedRouteElement} from '../../components/AuthorizedRouteElement.tsx';

export const DomainNamesLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <AuthorizedRouteElement rbacAction='ListDomainNames' redirectTo='/'>
                        <IndexPage/>
                    </AuthorizedRouteElement>
                }
            />
            <Route
                path='add'
                element={
                    <AuthorizedRouteElement rbacAction='CreateDomainName' redirectTo='/domain-names'>
                        <AddPage/>
                    </AuthorizedRouteElement>
                }
            />

            <Route
                path=':id'
                element={
                    <AuthorizedRouteElement rbacAction='GetDomainName' redirectTo='/domain-names'>
                        <EditPage/>
                    </AuthorizedRouteElement>
                }
            />
        </Routes>
    );
};
